(function ($, Drupal) {

  Drupal.behaviors.gallery = {

    attach: function (context, settings) {
      // Set up variables
      var gallery = $('.gallery');
      var closeGallery = $('.close-gallery');
      var topMenu = $('.top-menu');
      var secondaryMenu = $('.secondary-menu');
      var mainMenu = $('.main-menu');
      // The point where menu changes from mobile to desktop
      var mediaQuery = window.matchMedia( '(min-width: 1080px)' );

      function showGallery() {
        gallery.fadeIn();
        // Make sure we can't scroll the body underneath
        $('body').addClass('noscroll');
        // Add something to the body to tell us it's open
        $('body').addClass('gallery-open');
        // This will sit behind the menus if we don't hide them
        topMenu.hide();
        secondaryMenu.hide();
        mainMenu.hide();
        // Set focus on back button,
        // since it's the only clickable thing on the page
        closeGallery.focus();
      }

      function hideGallery() {
        gallery.fadeOut();
        // Make sure we can scroll the body again
        $('body').removeClass('noscroll');
        // Tell the body the gallery is no longer open
        $('body').removeClass('gallery-open');
        // Show the menus again - if the page is big enough
        if (mediaQuery.matches) {
          topMenu.show();
          secondaryMenu.show();
          mainMenu.show();
        }
      }

      // Show gallery when clicking more images button
      $(once('.lb-image', '.more-images')).each(function() {
        $(this).on('click', function(event) {
          showGallery();
        });
      });

      // Hide gallery when clicking back button
      $(once('.lb-image', closeGallery)).each(function() {
        $(this).on('click', function() {
          hideGallery();
        });
      });

      // Hide gallery when pressing escape
      $(document).keyup(function(event) {
       if (event.key === 'Escape') {
          hideGallery();
        }
      });

    }
  };
})(jQuery, Drupal);
